var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgZoomToFit = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 25
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Zoom to Fit"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 338",
  fill: "#fff",
  stroke: "#ece4e4"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h30v25H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M.5.5h29v24H.5z"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 239",
  d: "M12.932 18.034H9.865v-3.067",
  fill: "none",
  stroke: "#376996",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 246",
  d: "M19.932 14.967v3.067h-3.067",
  fill: "none",
  stroke: "#376996",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 241",
  d: "M9.865 11.033V7.966h3.067",
  fill: "none",
  stroke: "#376996",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 245",
  d: "M17.069 7.967h3.067v3.067",
  fill: "none",
  stroke: "#376996",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 240",
  d: "m9.865 17.93 3.475-3.475",
  fill: "none",
  stroke: "#376996",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 244",
  d: "m19.933 17.93-3.475-3.475",
  fill: "none",
  stroke: "#376996",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 242",
  d: "m9.865 7.966 3.475 3.475",
  fill: "none",
  stroke: "#376996",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 243",
  d: "m20.136 7.966-3.475 3.475",
  fill: "none",
  stroke: "#376996",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
export default SvgZoomToFit;